// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { harvestOperationAttributeId } from './HarvestOperationAttribute';
import { operatorId } from './Operator';
import { z } from 'zod';
export const harvestTabularRowId = (z.number());
export const harvestTabularRow = z.object({
    id: harvestTabularRowId,
    harvest_operation_attribute_id: harvestOperationAttributeId,
    sort_order: z.number(),
    index_value_text: z.string().nullable(),
    index_value_number: z.string().nullable(),
    index_value_timestamp: z.date().nullable(),
    data: z.unknown(),
    computed_data: z.unknown().nullable(),
    computed_errors: z.unknown().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    computed_units: z.unknown().nullable(),
});
export const harvestTabularRowInitializer = z.object({
    id: harvestTabularRowId.optional(),
    harvest_operation_attribute_id: harvestOperationAttributeId,
    sort_order: z.number().optional(),
    index_value_text: z.string().optional().nullable(),
    index_value_number: z.string().optional().nullable(),
    index_value_timestamp: z.date().optional().nullable(),
    data: z.unknown(),
    computed_data: z.unknown().optional().nullable(),
    computed_errors: z.unknown().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    computed_units: z.unknown().optional().nullable(),
});
export const harvestTabularRowMutator = z.object({
    id: harvestTabularRowId.optional(),
    harvest_operation_attribute_id: harvestOperationAttributeId.optional(),
    sort_order: z.number().optional(),
    index_value_text: z.string().optional().nullable(),
    index_value_number: z.string().optional().nullable(),
    index_value_timestamp: z.date().optional().nullable(),
    data: z.unknown().optional(),
    computed_data: z.unknown().optional().nullable(),
    computed_errors: z.unknown().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    computed_units: z.unknown().optional().nullable(),
});
//# sourceMappingURL=HarvestTabularRow.js.map